import i18next from "i18next";
import { useNavigate } from "react-router-dom";

export function useNavigation() {
  function slugify(text) {
    return text
      .toString()
      .normalize("NFKD") // 1.
      .replace(/[\u0300-\u036f]/g, "") // 2.
      .replace(/[^\w\s-]/g, "") // 3. (\w = [A-Za-z0-9_], \s = whitespace)
      .trim() // 4.
      .toLowerCase() // 4.
      .replace(/[\s_-]+/g, "-") // 5.
      .replace(/^-+|-+$/g, ""); // 6.
  }
  const navigate = useNavigate();

  function goToHome() {
    return "/";
  }
  function goToFeatured() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/featured`;
  }
  function goToProduct(category, title) {
    const lang = i18next.language;
    const slugTitle = slugify(title);
    return `/${lang}/${slugTitle}`;
  }

  function goToCategory(category) {
    const lang = i18next.language;
    const slugCategory = slugify(category);
    return `/${lang}/nicotine-pouches/${slugCategory}`;
  }
  function goToCheckout() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/checkout`;
  }
  function goToShop() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/nicotine-pouches`;
  }
  function goToBrands() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/brands`;
  }
  function goToLogin() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/signin`;
  }
  function goToRegister() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/signup`;
  }
  function goToVerification() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/verification`;
  }
  function goToForgotPassword() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/password`;
  }

  function goToThankYou() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/thank-you`;
  }
  //PRODUCT
  function goToBestSeller() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/best-seller`;
  }
  function goToNewArrivals() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/new-arrivals`;
  }
  //PROFILE
  function goToAccount() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/account`;
  }
  function goToProfile() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/account/profile`;
  }
  function goToSavedCards() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/account/saved-cards`;
  }
  function goToAddressBook() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/account/address-book`;
  }
  function goToOrderHistory() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/account/orders`;
  }
  function goToAddAddressBook() {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/account/address-book/new`;
  }
  function goToEditAddressBook(id) {
    const currentLanguage = i18next.language;
    return `/${currentLanguage}/account/address-book/edit/${id}`;
  }
  //
  function goToPrivacyPolicy() {
    return `/privacy-policy`;
  }
  function goToReturnPolicy() {
    return `/return-and-refund-policy`;
  }
  function goToTermsConditions() {
    return `/terms-conditions`;
  }

  return {
    goToHome,
    goToFeatured,
    goToProduct,
    goToCategory,
    goToShop,
    goToBrands,
    goToLogin,
    goToRegister,
    goToVerification,
    goToForgotPassword,
    goToCheckout,
    goToThankYou,

    //product
    goToBestSeller,
    goToNewArrivals,

    //profile
    goToAccount,
    goToProfile,
    goToSavedCards,
    goToAddressBook,
    goToOrderHistory,
    goToAddAddressBook,
    goToEditAddressBook,

    //bzvz
    goToPrivacyPolicy,
    goToReturnPolicy,
    goToTermsConditions,
  };
}
